import { render, staticRenderFns } from "./ClinicEntityTexts.vue?vue&type=template&id=36f6e859&"
import script from "./ClinicEntityTexts.vue?vue&type=script&lang=js&"
export * from "./ClinicEntityTexts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports